import { ChangeDetectorRef, Component, HostListener, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AppPages } from '@constants/app-pages';
import { Protecao, ServicoAdicional, Tarifa, Taxa } from '@domain/dto/vehicle/vehicle-get.dto';
import { environment } from '@environment/environment';
import { ReservaService } from '@infra/reserva/reserva.service';
import { BottomSheetComponent } from '@presentation/view/shared/components/bottom-sheet/bottom-sheet.component';
import { DateUtil } from 'src/app/shared/utils/date.util';
import { ProtectionDialogComponent } from './protection-dialog/protection-dialog.component';

@Component({
  selector: 'app-additionals',
  templateUrl: './additionals.component.html',
  styleUrls: ['./additionals.component.scss'],
})
export class AdditionalsComponent implements OnInit {
  isLoading: boolean = false;
  showTariffsPanel: boolean = true;
  showProtectionsPanel: boolean = false;
  showAdditionalsPanel: boolean = false;
  isMobile: boolean = false;
  tariffSelected!: boolean;
  protectionsSelected!: boolean;
  additionalsSelected!: boolean;
  secondGroup: any;
  myForm!: FormGroup;
  tariffs!: Tarifa[];
  protections!: Protecao[];
  additionals!: ServicoAdicional[];
  taxas!: Taxa[];
  diasReserva = this.diffDays();
  additionalsPrice: number = 0;
  valorNaoIncidenciaAdicionais: number = 0;
  naoIncidirTaxaProtecao: boolean = false;
  totalPrice: number = 0;
  totalPriceDiscount: number = 0;
  taxaServico: number = 0;
  totalTaxa: number = 0;
  taxasPrice: number = 0;
  hideProtectionPanel: boolean = false;
  hideAdditionalPanel: boolean = false;
  valorDiaria: number = 0;
  totalDiarias: number = 0;
  diasPeriodo: number = 0;
  quantidadeHorasExtras: number = 0;
  valorHoraExtra: number = 0;
  valorTotalHoraExtras: number = 0;
  diaSomado: boolean = false;
  totalDescontoTarifa: number = 0;
  adicionaisSelecionado = false;

  currentLanguage: string;
  customCurrencyDefault: string;

  constructor(
    public reservaService: ReservaService,
    private _bottomSheet: MatBottomSheet,
    private router: Router,
    private readonly dialog: MatDialog,
    private cdr: ChangeDetectorRef
  ) {
    this.currentLanguage = localStorage.getItem('language')
    this.customCurrencyDefault = sessionStorage.getItem('customCurrencyDefault')
  }

  async ngOnInit(): Promise<void> {
    await this.reservaService.clearProtectionsTariffAndAdditionalsData();

    this.tariffs = this.reservaService?.vehicle?.Tarifas;
    this.protections = this.reservaService?.vehicle?.Protecoes;

    this.taxas = [];

    this.additionals = [];

    if (this.protections.length <= 0) {
      this.hideProtectionPanel = true;
      this.protectionsSelected = true;
    }
    if (this.additionals?.length <= 0) {
      this.hideAdditionalPanel = true;
      this.additionalsSelected = true;
    }
    this.onResize();
    this.defineObjectsQuantityAdditionals();
    this.scrollTop();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event?: UIEvent) {
    if (window.innerWidth <= 960) this.isMobile = true;
    else this.isMobile = false;
  }
  diffDays() {

    const firstDate = this.reservaService?.homeData?.firstDateSelected;
    const secondDate = this.reservaService?.homeData?.secondDateSelected;


    if (!firstDate || !secondDate) {
      console.error('Datas inválidas ou não definidas:', { firstDate, secondDate });
      return 1; // Retorna 1 como padrão
    }

    let date1: Date;
    let date2: Date;

    // Verifica o idioma e ajusta o formato das datas
    if (environment.defaultLanguage === 'en-US') {
      date1 = new Date(firstDate);
      date2 = new Date(secondDate);
    } else {
      date1 = new Date(DateUtil.changeDDMMtoMMDD(firstDate));
      date2 = new Date(DateUtil.changeDDMMtoMMDD(secondDate));
    }

    // Valida se as datas são válidas
    if (isNaN(date1.getTime()) || isNaN(date2.getTime())) {
      console.error('Erro ao converter as datas:', { date1, date2 });
      return 1; // Retorna 1 como padrão
    }
    const timeDiff = Math.abs(date2.getTime() - date1.getTime());
    let diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));

    return diffDays;
  }
  defineObjectsUncheckedTarifas() {
    this.reservaService?.vehicle?.Tarifas?.forEach((item: any, index: number) => {
      this.reservaService.vehicle.Tarifas[index].checked = false;
    });
  }

  defineObjectsUncheckedProtecoes() {
    this.reservaService?.vehicle?.Protecoes?.forEach((item: any, index: number) => {
      this.reservaService.vehicle.Protecoes[index].checked = false;
    });
  }

  defineObjectsQuantityAdditionals() {
    this.additionals?.forEach((item: any, index: number) => {
      this.additionals[index].Quantidade = 0;
    });

    for (let adicional of (this.additionals || [])) {
      if (adicional.QuantidadeGrupo > 0) {
        adicional.Quantidade = adicional.QuantidadeGrupo
      }
    }

    this.reservaService.additionalsData = this.additionals?.filter((item) => item.Quantidade > 0) || [];
    this.reservaService.taxasData = this.taxas || [];
    this.adicionaisSelecionado = this.additionals?.some((item) => item.Quantidade > 0) ?? false;
    this.calculateAdditionalsPrice();
  }

  openBottomSheet(): void {
    this._bottomSheet.open(BottomSheetComponent, {
      panelClass: 'mat-bottom-sheet-container',
      data: {
        showSecondDiv: true,
        totalPrice: this.totalPrice,
        totalPriceDiscount: this.totalPriceDiscount,
        additionalsPrice: this.additionalsPrice,
        additionalsArray: this.additionals,
        taxasArray: this.taxas,
        taxasPrice: this.taxasPrice
      },
    });
  }

  changeRadioGroupTarifas(index: number) {
    this.defineObjectsUncheckedTarifas();
    this.reservaService.vehicle.Tarifas[index].checked = true;
    this.reservaService.tariffData = this.reservaService.vehicle.Tarifas[index];

    this.setAdicionais(index);
    this.setTaxas(index);

    this.hideAdditionalPanel = this.additionals.length <= 0;
    this.additionalsSelected = this.additionals.length <= 0;
    this.defineObjectsQuantityAdditionals();
    this.tariffSelected = true;
    this.showProtectionsPanel = false;
    this.showAdditionalsPanel = false;
    this.showProtectionsPanel = true;
    this.calculateAdditionalsPrice();
  }

  private setAdicionais(index: number): void {
    const tarifaAdicionais: ServicoAdicional[] = this.reservaService.vehicle.Tarifas[index]?.ServicosAdicionais || [];
    const veiculoAdicionais: ServicoAdicional[] = this.reservaService?.vehicle?.ServicosAdicionais || [];

    const tarifaCodigosSet = new Set(tarifaAdicionais.map((a: any) => a.CodigoServicoAdicional));
    const adicionaisNaoRepetidos = veiculoAdicionais.filter((a: any) => !tarifaCodigosSet.has(a.CodigoServicoAdicional));
    this.additionals = [...tarifaAdicionais, ...adicionaisNaoRepetidos];
  };

  private setTaxas(index: number): void {
    const tarifaTaxas: any[] = this.reservaService.vehicle.Tarifas[index]?.Taxas || [];
    const veiculoTaxas: any[] = this.reservaService?.vehicle?.Taxas || [];

    const tarifaTaxasSet = new Set(tarifaTaxas.map((t: any) => t.CodigoServicoAdicional));
    const taxasNaoRepetidas = veiculoTaxas.filter((t: any) => !tarifaTaxasSet.has(t.CodigoServicoAdicional));
    this.taxas = [...tarifaTaxas, ...taxasNaoRepetidas];
  };

  changeRadioGroupProtecoes(index: number) {
    this.defineObjectsUncheckedProtecoes();
    this.reservaService.vehicle.Protecoes[index].checked = true;
    this.reservaService.protectionData = this.reservaService.vehicle.Protecoes[index];
    this.protectionsSelected = true;
    this.showProtectionsPanel = false;
    this.showProtectionsPanel = false;
    this.showAdditionalsPanel = true;
    this.calculateAdditionalsPrice();
  }

  sumQuantity(index: number) {

    this.additionals[index].Quantidade++;


    // Atualizando a lista de itens adicionais na reserva
    this.reservaService.additionalsData = this.additionals.filter((item) => item.Quantidade > 0);
    this.adicionaisSelecionado = this.additionals.some((item) => item.Quantidade > 0);

    this.calculateAdditionalsPrice();
  }

  minusQuantity(index: number, item: any) {
    if (item.Quantidade > (item.QuantidadeGrupo || 0)) {
      if (this.additionals[index]?.Quantidade > 0) this.additionals[index].Quantidade--;
      this.reservaService.additionalsData = this.additionals?.filter((i: any) => i.Quantidade > 0) || [];
      this.adicionaisSelecionado = this.additionals.some((i: any) => i.Quantidade > 0);
      this.calculateAdditionalsPrice();
    }
  }

  calculateAdditionalsPrice() {
    const taxaAdministrativa = this.reservaService?.taxaAdministrativa ?? 0;
    this.additionalsPrice = 0;
    this.taxaServico = 0;
    this.valorNaoIncidenciaAdicionais = 0;

    if (this.reservaService.additionalsData && this.reservaService.additionalsData.length > 0) {
      this.reservaService.additionalsData.map((i: any) => {
        if (i?.CalculoPorDiarias == 'S') {
          const value = i.Quantidade * i.Valor * this.diasReserva;
          if (i?.AplicarTaxaServicos == 'S' && i?.NaoIncidirTaxas == 'N') {
            const valueSumTaxa = (taxaAdministrativa / 100) * value;
            this.taxaServico += valueSumTaxa;
            this.additionalsPrice += valueSumTaxa + value;
          } else {
            this.additionalsPrice += value;
            if (i?.NaoIncidirTaxas == 'S')
              this.valorNaoIncidenciaAdicionais += value;
          }
        } else {
          const value = i.Quantidade * i.Valor;
          if (i?.AplicarTaxaServicos == 'S' && i?.NaoIncidirTaxas == 'N') {
            const valueSumTaxa = (taxaAdministrativa / 100) * value;
            this.taxaServico += valueSumTaxa;
            this.additionalsPrice += valueSumTaxa + value;
          } else {
            this.additionalsPrice += i.Quantidade * i.Valor;
            if (i?.NaoIncidirTaxas == 'S')
              this.valorNaoIncidenciaAdicionais += i.Quantidade * i.Valor;
          }
        }
      });
    }
    this.calculateTotalPrice();
    this.cdr.detectChanges();
  }

  calculateTotalPrice() {
    const taxaAdministrativa = this.reservaService?.taxaAdministrativa ?? 0;
    this.totalPrice = 0;
    this.naoIncidirTaxaProtecao = this.reservaService?.protectionData?.NaoIncidirTaxas == 'S' ? true : false
    const protectionRuleFlag = this.reservaService?.protectionData?.CobrarDiariaAMaisHoraExtra === 'S';
    const threshold = +(this.reservaService?.protectionData?.QuantidadeHorasInicioCobrancaDiariaHoraExtra || 0);
    const isEnglish = environment.defaultLanguage === 'en-US';
    const rawFirstHour = this.reservaService?.homeData?.firstHourSelected;
    const rawSecondHour = this.reservaService?.homeData?.secondHourSelected;
    let diasProtecao = this.diasReserva;
    if (rawFirstHour && rawSecondHour) {
      const to24 = (t: string) => {
        if (!t) return '00:00';
        const [time, modifier] = t.trim().split(' ');
        if (!modifier) return DateUtil.formatTo24Hour(t);
        let [hours, minutes] = time.split(':').map(Number);
        if (modifier?.toLowerCase() === 'pm' && hours < 12) hours += 12;
        if (modifier?.toLowerCase() === 'am' && hours === 12) hours = 0;
        return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
      };
      const firstHour24 = isEnglish ? to24(rawFirstHour) : DateUtil.formatTo24Hour(rawFirstHour);
      const secondHour24 = isEnglish ? to24(rawSecondHour) : DateUtil.formatTo24Hour(rawSecondHour);
      const [fh, fm] = firstHour24.split(':') || ['0','0'];
      const [sh, sm] = secondHour24.split(':') || ['0','0'];
      const firstTotalMinutes = (+fh) * 60 + (+fm);
      const secondTotalMinutes = (+sh) * 60 + (+sm);
      let diffMinutes = secondTotalMinutes - firstTotalMinutes;
      const cortesiaMinutes = (+sessionStorage.getItem('maximoHoraExtraCortesia') || 0) * 60;
      if (cortesiaMinutes > 0 && diffMinutes < cortesiaMinutes) diffMinutes = 0;
      const maxDifHour = +sessionStorage.getItem('maximoHoraExtra') || 0;
      const maxDifMinutes = maxDifHour * 60;
      const horasExtras = diffMinutes > 0 ? Math.floor(diffMinutes / 60) : 0;
      const incrementoDiasPorHorasExtras = protectionRuleFlag && threshold > 0 ? Math.floor(horasExtras / threshold) : 0;
      if (incrementoDiasPorHorasExtras > 0) diasProtecao += incrementoDiasPorHorasExtras;
    }
    const protectionValue = this.reservaService?.protectionData?.ValorProtecao
      ? +this.reservaService?.protectionData?.ValorProtecao * diasProtecao
      : 0;

    let tariffValue = 0
    let valorDescontoTarifa = 0
    if (this.reservaService?.cupomData?.Percentual) {
      valorDescontoTarifa = (this.reservaService?.cupomData?.Percentual / 100) * this.reservaService?.tariffData.ValorPeriodoVeiculo;
    }

    if (this.reservaService?.tariffData?.TipoCobranca === 'P') {
      this.valorDiaria = (this.reservaService?.tariffData.ValorPeriodoVeiculo - (this.reservaService?.tariffData.ValorDesconto ?? 0) - valorDescontoTarifa) / this.reservaService?.tariffData.DiariaTermino;
      this.totalDiarias = this.reservaService?.tariffData.PeriodoTarifa;
      this.diasPeriodo = this.reservaService?.tariffData.DiariaTermino;
      if (this.totalDiarias < this.diasPeriodo) {
        tariffValue = this.reservaService?.tariffData?.ValorPeriodoVeiculo - this.reservaService?.tariffData?.ValorDesconto - valorDescontoTarifa
      } else {
        tariffValue = (this.totalDiarias * this.valorDiaria) - this.reservaService?.tariffData?.ValorDesconto - valorDescontoTarifa
      }
      this.totalDescontoTarifa = valorDescontoTarifa
    } else {
      tariffValue = (+this.reservaService?.tariffData?.ValorPeriodoVeiculo - (this.reservaService?.tariffData.ValorDesconto ?? 0) - valorDescontoTarifa) * this.diasReserva
      this.totalDescontoTarifa = valorDescontoTarifa * this.diasReserva
    }

    let protectionValueSumTaxa = 0
    if (this.naoIncidirTaxaProtecao == false) {
      protectionValueSumTaxa = (taxaAdministrativa / 100) * protectionValue;
    }
    const tariffValueSumTaxa = (taxaAdministrativa / 100) * tariffValue;

    const products = this.additionalsPrice + (protectionValue ?? 0) + tariffValue;

    const productsSumTaxa = protectionValueSumTaxa + tariffValueSumTaxa;

    this.totalTaxa = 0

    // Calcula as taxas
    if (this.taxas && this.taxas.length > 0) {
      for (let taxa of this.taxas) {
        if (taxa.Tipo == 'P') {
          if (taxa.IncideAdicionais == 'S')
            this.totalTaxa = this.totalTaxa + ((this.additionalsPrice - this.valorNaoIncidenciaAdicionais) * taxa.PercentualTaxa / 100)
          if (taxa.IncideValorProtecoes == 'S' && this.naoIncidirTaxaProtecao == false)
            this.totalTaxa = this.totalTaxa + ((protectionValue ?? 0) * taxa.PercentualTaxa / 100)
          if (taxa.IncideValorPeriodo == 'S')
            this.totalTaxa = this.totalTaxa + (tariffValue * taxa.PercentualTaxa / 100)
        } else {
          this.totalTaxa = taxa.ValorTaxa
        }
      }
    }
    this.taxasPrice = this.totalTaxa;
    this.taxaServico += productsSumTaxa;
    this.totalPrice += products + productsSumTaxa + this.totalTaxa;
   
    this.totalPriceDiscount = this.totalPrice;

    this.calcularHorasExtras()
  }
  calcularHorasExtras() {
    const isEnglish = environment.defaultLanguage === 'en-US';
    const maxDifHour = +sessionStorage.getItem('maximoHoraExtra') || 0;

    const valorHoraExtra = this.reservaService?.tariffData?.ValorHoraExcedente || 0;
    this.valorHoraExtra = valorHoraExtra;

    // Pegando as horas brutas
    const rawFirstHour = this.reservaService?.homeData?.firstHourSelected;
    const rawSecondHour = this.reservaService?.homeData?.secondHourSelected;

    if (!rawFirstHour || !rawSecondHour) return;

    const firstHour24 = isEnglish
      ? convertTo24HourFormat(rawFirstHour)
      : DateUtil.formatTo24Hour(rawFirstHour);

    const secondHour24 = isEnglish
      ? convertTo24HourFormat(rawSecondHour)
      : DateUtil.formatTo24Hour(rawSecondHour);

    const [firstHourStr, firstMinuteStr] = firstHour24.split(':') || ['0', '0'];
    const [secondHourStr, secondMinuteStr] = secondHour24.split(':') || ['0', '0'];

    const firstTotalMinutes = (+firstHourStr) * 60 + (+firstMinuteStr);
    const secondTotalMinutes = (+secondHourStr) * 60 + (+secondMinuteStr);
    let diffMinutes = secondTotalMinutes - firstTotalMinutes;

    const maxDifMinutes = maxDifHour * 60;

    const firstDate = this.reservaService?.homeData?.firstDateSelected;
    const secondDate = this.reservaService?.homeData?.secondDateSelected;
    const sameDate = firstDate === secondDate;

    if (sameDate) {
      this.diasReserva = 1;
      this.quantidadeHorasExtras = 0;
      this.valorTotalHoraExtras = 0;
      sessionStorage.setItem('extraHours', JSON.stringify({
        quantidadeHorasExtras: 0,
        valorHoraExtra: this.valorHoraExtra,
        valorTotalHoraExtras: 0
      }));
      return;
    }

    const cortesiaMinutos = (+sessionStorage.getItem('maximoHoraExtraCortesia') || 0) * 60;
    if (cortesiaMinutos > 0 && diffMinutes < cortesiaMinutos) {
      diffMinutes = 0;
    }

    const shouldSumDaily = maxDifHour > 0 && diffMinutes >= maxDifMinutes && this.diasReserva > 0;
    if (shouldSumDaily && this.diaSomado === false) {
      this.diasReserva += 1;
      this.diaSomado = true;
    }

    if (this.diasReserva === 0) {
      this.diasReserva = 1;
    }

    if (shouldSumDaily) {
      this.quantidadeHorasExtras = 0;
      this.valorTotalHoraExtras = 0;
    } else if (diffMinutes > 0) {
        const horasExtrasArredondadas = Math.floor(diffMinutes / 60);
        this.quantidadeHorasExtras = horasExtrasArredondadas;
        this.valorTotalHoraExtras = horasExtrasArredondadas * valorHoraExtra;
        this.totalPrice += this.valorTotalHoraExtras;
      } else {
      this.quantidadeHorasExtras = 0;
      this.valorTotalHoraExtras = 0;
    }

    sessionStorage.setItem('extraHours', JSON.stringify({
      quantidadeHorasExtras: this.quantidadeHorasExtras,
      valorHoraExtra: this.valorHoraExtra,
      valorTotalHoraExtras: this.valorTotalHoraExtras
    }));
    this.totalPriceDiscount = this.totalPrice;

    // Função auxiliar embutida (pode mover para utilitário se preferir)
    function convertTo24HourFormat(time12h: string): string {
      if (!time12h) return '00:00';
      const [time, modifier] = time12h.trim().split(' ');
      let [hours, minutes] = time.split(':').map(Number);

      if (modifier?.toLowerCase() === 'pm' && hours < 12) {
        hours += 12;
      }
      if (modifier?.toLowerCase() === 'am' && hours === 12) {
        hours = 0;
      }

      return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
    }
  }

  scrollTop() {
    let elmntToView = document.getElementById('top')!;
    elmntToView.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
  }

  openDialog(protecao: Protecao) {
    this.dialog.open(ProtectionDialogComponent, {
      autoFocus: false,
      panelClass: 'protect-dialog',
      data: protecao,
      maxWidth: '380px',
      width: '100%',
    });
  }

  submitForm() {
    sessionStorage.setItem('summaryDataPayment', JSON.stringify({
      totalDiarias: this.totalDiarias,
      totalPrice: this.totalPrice,
      additionalsPrice: this.additionalsPrice,
      totalPriceDiscount: this.totalPriceDiscount,
      additionals: this.additionals,
      taxas: this.taxas,
      valorDiaria: this.valorDiaria,
      diasPeriodo: this.diasPeriodo,
      taxasPrice: this.taxasPrice,
      taxaServico: this.taxaServico
    }));
    sessionStorage.setItem('totalPrice', this.totalPrice.toString())
    sessionStorage.setItem('totalPriceDiscount', this.totalPriceDiscount.toString())
  }

  async nextPage() {
    sessionStorage.setItem('summaryDataPayment', JSON.stringify({
      totalDiarias: this.totalDiarias,
      totalPrice: this.totalPrice,
      additionalsPrice: this.additionalsPrice,
      totalPriceDiscount: this.totalPriceDiscount,
      additionals: this.additionals,
      taxas: this.taxas,
      valorDiaria: this.valorDiaria,
      diasPeriodo: this.diasPeriodo,
      taxasPrice: this.taxasPrice,
      taxaServico: this.taxaServico
    }));
  }

  async backPage() {
    this.router.navigateByUrl(AppPages.VEHICLES, { state: { useDataFromStorage: true } });
  }

  get isStepValid(): boolean {
    return this.tariffSelected && this.protectionsSelected;
  }

  public verificaQuantidadeGrupo(item: any): boolean {
    if (item.Quantidade == item.QuantidadeGrupo)
      return false
    else
      return true
  }

}
